import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=e640590a&scoped=true&"
import script from "./Percentage.vue?vue&type=script&lang=ts&"
export * from "./Percentage.vue?vue&type=script&lang=ts&"
import style0 from "./Percentage.vue?vue&type=style&index=0&id=e640590a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e640590a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
